import { render, staticRenderFns } from "./ConfirmKitArchive.vue?vue&type=template&id=8ed72142&scoped=true&"
import script from "./ConfirmKitArchive.vue?vue&type=script&lang=js&"
export * from "./ConfirmKitArchive.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmKitArchive.vue?vue&type=style&index=0&id=8ed72142&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed72142",
  null
  
)

export default component.exports